// @constants
export const SET_SESSION_DATA = 'SET_SESSION_DATA';

const getSessionFromSearch = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('sid');
};

export const setSessionData = () => (dispatch) => {
    let user = window.fanSizer?.settings.user;
    if (!user) {
        user = {
            sid: getSessionFromSearch() || null
        };
    }
    dispatch({
        type: SET_SESSION_DATA,
        payload: user
    });
};
